import Vue from 'vue'
import Vuex from 'vuex'
import global from "./modules/global"
import settings from "./modules/settings"
import session from "./modules/session"
import users from "./modules/users"
import calendar from "./modules/calendar"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global,
    settings,
    session,
    users,
    calendar
  }
})
